'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _setTimeout = require('common/utils/set-timeout');

var _setTimeout2 = _interopRequireDefault(_setTimeout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* -----------  LOGIN  ------------------------------------ */

var _ref = _jsx('input', {
    type: 'hidden',
    name: 'resend',
    value: '0'
});

var LogInVerificationForm = _react2['default'].createClass({
    displayName: 'LogInVerificationForm',


    propTypes: {
        'errorMsg': _react2['default'].PropTypes.string,
        'redirectUrl': _react2['default'].PropTypes.string,
        'tabOffset': _react2['default'].PropTypes.number,
        'emailAddress': _react2['default'].PropTypes.string.isRequired,
        'rememberMe': _react2['default'].PropTypes.bool.isRequired,
        'phoneNumberLast2': _react2['default'].PropTypes.string.isRequired,
        'siteCode': _react2['default'].PropTypes.string.isRequired,
        'signature': _react2['default'].PropTypes.string.isRequired,
        'zendeskWidgetEnabled': _react2['default'].PropTypes.bool.isRequired
    },

    componentDidMount: function componentDidMount() {

        var self = this;
        var root = $(_reactDom2['default'].findDOMNode(this));
        var codeInput = root.find(".m-login--verification--code input");

        (0, _setTimeout2['default'])(function () {
            codeInput.focus();
        }, 500);

        $('.m-login--verification--links--modal').overlay({
            mask: "rgba(100, 100, 100, 0.65)",
            speed: 0,
            onClose: function onClose() {
                self.hideHelp();
            }
        });
    },

    onSubmit: function onSubmit(evt) {},

    resendCode: function resendCode(evt) {
        evt.preventDefault();
        var root = $(_reactDom2['default'].findDOMNode(this));
        $('input[name="resend"]', root).val('1');
        $('#login_form', root).submit();
    },

    enterRecoveryCode: function enterRecoveryCode(evt) {
        evt.preventDefault();
        var root = $(_reactDom2['default'].findDOMNode(this));
        $('.m-login--verification--instructions', root).hide();
        $('.m-login--verification--recovery', root).show();
        $('.m-login--verification--code input', root).attr('placeholder', 'Enter recovery code');
        this.hideHelp();
    },

    contactSupport: function contactSupport(evt) {
        evt.preventDefault();
        this.hideHelp();
        if (this.props.zendeskWidgetEnabled) {
            zE(function () {
                zE.activate({ hideOnClose: true });
            });
        } else {
            UserVoice.showLightbox();
        }
    },

    showHelp: function showHelp(evt) {
        evt.preventDefault();
        var root = $(_reactDom2['default'].findDOMNode(this));
        $('.m-login--verification--links--modal', root).overlay().load();
        $('#problemLink', root).hide();
    },

    hideHelp: function hideHelp() {
        var root = $(_reactDom2['default'].findDOMNode(this));
        $('.m-login--verification--links--modal', root).overlay().close();
        $('#problemLink', root).show();
    },

    render: function render() {

        var targetUrl = _hfReactHelper2['default'].urlHelper("account/logInVerification", this.props.siteCode);
        var tabOffset = parseInt(this.props.tabOffset || 0, 10);
        var err = this.props.errorMsg ? _jsx('p', {
            className: 'm-login--verification--error'
        }, void 0, this.props.errorMsg) : null;

        return _jsx('div', {
            className: 'm-login is-verification'
        }, void 0, _react2['default'].createElement(
            'form',
            { ref: 'login_form', className: 'm-login--form', id: 'login_form', action: targetUrl, method: 'POST' },
            _jsx('div', {}, void 0, _jsx('div', {
                className: 'columns small-12'
            }, void 0, _jsx('h3', {
                className: 'm-login--verification--title'
            }, void 0, '2-step account verification')), _jsx('p', {
                className: 'columns small-12 l-text-centered m-login--verification--instructions'
            }, void 0, 'We just sent you a text message to (***) ***-**', this.props.phoneNumberLast2, ' with your code. Please enter the code to log in.'), _jsx('p', {
                className: 'columns small-12 l-text-centered m-login--verification--recovery'
            }, void 0, 'Enter the recovery code that was given to you when you enabled 2-Factor Authentication. ', _jsx('b', {}, void 0, 'The code will become void and 2-Factor Authentication will be disabled.')), _jsx('input', {
                type: 'hidden',
                name: 'verification[last2]',
                value: this.props.phoneNumberLast2
            }), _jsx('input', {
                type: 'hidden',
                name: 'verification[email_address]',
                value: this.props.emailAddress
            }), _jsx('input', {
                type: 'hidden',
                name: 'verification[rm]',
                value: this.props.rememberMe ? '1' : '0'
            }), _jsx('input', {
                type: 'hidden',
                name: 'verification[redirect_url]',
                value: this.props.redirectUrl
            }), _jsx('input', {
                type: 'hidden',
                name: 'verification[signature]',
                value: this.props.signature
            }), _ref, _jsx('div', {
                className: 'm-login--verification--code'
            }, void 0, _jsx('input', {
                type: 'text',
                name: 'verification[code]',
                className: 'm-login--text-input',
                placeholder: 'Enter code',
                maxLength: '6',
                tabIndex: tabOffset
            }), err), _jsx('div', {
                className: 'small-10 small-offset-1 text-center'
            }, void 0, _jsx(_button2['default'], {
                onClick: this.onSubmit,
                buttonClass: '',
                buttonText: 'VERIFY',
                buttonColor: 'grasshopper',
                buttonHoverColor: 'castle-rock',
                buttonTabIndex: tabOffset + 1
            })), _jsx('div', {
                className: 'm-login--verification--links'
            }, void 0, _jsx('a', {
                href: 'javascript:;',
                id: 'problemLink',
                onClick: this.showHelp
            }, void 0, 'Problems receiving your code?'), _jsx('div', {
                className: 'm-login--verification--links--modal form-overlay'
            }, void 0, _jsx('div', {
                className: 'm-login--verification--links--modal--title'
            }, void 0, 'Try one of these methods'), _jsx('a', {
                href: 'javascript:;',
                id: 'resendCodeLink',
                className: 'first small-4 column',
                onClick: this.resendCode
            }, void 0, 'Resend me the code'), _jsx('a', {
                href: 'javascript:;',
                id: 'recoveryLink',
                className: 'middle small-4 column',
                onClick: this.enterRecoveryCode
            }, void 0, 'Use my recovery code'), _jsx('a', {
                href: 'javascript:;',
                id: 'helpLink',
                className: 'last small-4 column',
                onClick: this.contactSupport
            }, void 0, 'Contact support for help'))))
        ));
    }
});

module.exports = LogInVerificationForm;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/login-verification-form.jsx
 ** module id = 758
 ** module chunks = 0
 **/